import { connect } from 'react-redux';
import CompanyView from './companies-view';
import { getCompanies, selectCompany, createCompanyWithSetup, suggestTemplates, deleteCompany } from '../../reducers/companies';

const mapStateToProps = state => ({
    companies: state.companies.companies,
    selectedCompanyId: state.companies.selectedCompanyId,
    user: state.auth.user,
})

const mapDispatchToProps = dispatch => ({
    dispatchGetCompanies: () => dispatch(getCompanies()),
    dispatchSelectCompany: (id, callback) => dispatch(selectCompany(id, callback)),
    dispatchCreateCompanyWithSetup: (company, templates) => dispatch(createCompanyWithSetup(company, templates)),
    dispatchSuggestTemplates: (description, existing, refinement) => dispatch(suggestTemplates(description, existing, refinement)),
    dispatchDeleteCompany: (id) => dispatch(deleteCompany(id)),
})

const header = connect(mapStateToProps, mapDispatchToProps)(CompanyView);

export default header;
